/**
 * Whether this conversation is over, from either thing that knows.
 *
 * `ended` is the local flag `endSession` sets when its mutation answers. It is
 * the only signal during the tick the learner taps "All done", and it is gone
 * the moment the screen unmounts — so on its own it made the ending ceremony a
 * thing you had to be looking at to ever see. A reload a second later, or a
 * return to the conversation's own URL, showed a finished session as though it
 * were still running: no stars, no debrief, and a microphone button offering to
 * record into a session the server had already closed.
 *
 * The status is the durable half, read with the turns when the screen mounts.
 * Together they cover both directions: the flag catches an ending that happens
 * while you are here, and the status catches one that already happened.
 *
 * Anything that is not `ACTIVE` counts as finished, including Relay's
 * `'%future added value'` for a status this client does not know yet. A status
 * added later will be some further stage of ending — the enum has no room for
 * "more active than active" — so treating an unknown one as finished fails
 * towards the honest screen rather than towards a live-looking one.
 */
export function sessionFinished({ ended, status }: { ended: boolean; status: string | null }): boolean {
  if (ended) return true;
  return status !== null && status !== 'ACTIVE';
}
